module.exports = __webpack_public_path__ + "img/wxjc.972d3346.png";